import React, { useState } from "react";
import {
  Grid,
  Type,
  Button
} from "mesh-component-library";
import _uniqueId from 'lodash/uniqueId';
import { useLocale } from "../../contexts/LocaleContext";
import { TRANSLATION_CONSTANTS } from "../../app-consts/translations";
import CONSTANTS from "../../app-consts/appConstants";
import LookUpFormHeader from "./Components/LookUpFormHeader";
import FormValidators from "../../utilities/form-validators";
import Form from '../../components/form';
import FormField from '../../components/form-field';

const TransactionNumberLookup = ({
  partnerDetails,
  dispatchCommonBenefitsLookup,
  showModal,
  closeModal,
  setCurrentLookup,
}) => {
  const [id] = useState(() => _uniqueId());
  const { appId, experience } = partnerDetails;
  const primary = experience?.lookupMethods?.components?.primary;

  const [transactionNumber, setTransactionNumber] = useState("");
  const [transactionNumberHasError, setTransactionNumberHasError] = useState(false);
  const getTranslatedText = useLocale();

  const onTransactionNumberChange = (e) => {
    const sanitized = (e.target?.value || "").replace(/[^0-9_]/g, "").slice(0, 20);
    setTransactionNumber(sanitized);
    setTransactionNumberHasError(false);
    return sanitized;
  };

  const continueClick = () => {
    const user = {
      transactionNumber,
      phoneLookup: false,
      appId,
      lookupType: CONSTANTS.TRANSACTION_NUMBER_LOOKUP,
    };
    dispatchCommonBenefitsLookup(user);
  };

  const onSubmit = () => {
    const content = (
      <div>
        <p>
          <span>{getTranslatedText(TRANSLATION_CONSTANTS.TRANSACTION_NUMBER)}:</span>{" "}
          {transactionNumber}
        </p>
      </div>
    );
    const options = {
      titleHtml: content,
      yesNoSelected,
    };

    showModal(options);
  };

  const yesNoSelected = ({ target: { value } }) => {
    closeModal();
    if (value === "yes") {
      continueClick();
    }
  };

  const searchByPhoneNumberLastname = () => {
    setCurrentLookup(primary);
  };

  return (
    <>
      <React.Fragment>
        <LookUpFormHeader titleText={getTranslatedText(TRANSLATION_CONSTANTS.NEED_INFO_BENEFITS)} id={`we-need-some-info-to-find-your-benefits-transaction-number-${id}`}/>
        <Form id={`transactionNumberLookupForm-${id}`}
            className="c-container-lookup__form"
            validateOnBlur={true}>
          <FormField
            id="transactionNumberId"
            errorText={getTranslatedText(TRANSLATION_CONSTANTS.PLEASE_ENTER_YOUR_TRANSACTION_NUMBER)}
            name="transactionNumberId"
            label={getTranslatedText(TRANSLATION_CONSTANTS.TRANSACTION_NUMBER)}
            onChange={onTransactionNumberChange}
            regex={/[^0-9_]/g}
            value={transactionNumber}
            validators={[FormValidators.validateTransactionNumber]}
            hasError={transactionNumberHasError}
            required
            type="text"
            maxLength={20}
            infoPopup={getTranslatedText(TRANSLATION_CONSTANTS.TRANSACTION_NUMBER_TOOLTIP)}
            data-testid="transaction-number-field"
          />
          <Button
            size="lg"
            hasUpgrade
            id="lookup-continue"
            disabled={!FormValidators.validateTransactionNumber(transactionNumber)}
            onClick={onSubmit}
            data-testid="transaction-number-continue"
            utils={{
              fullWidth: true,
            }}
          >
            {getTranslatedText(TRANSLATION_CONSTANTS.CONTINUE)}
          </Button>
        </Form>
        {primary && (
          <>
            <Grid utils={{ vrTop: "md", vrBottom: "md" }}>
              <Grid.Column>
                <Type element="span" size="4xl" variant="darker" weight="normal">
                  - {getTranslatedText(TRANSLATION_CONSTANTS.OR)} -
                </Type>
              </Grid.Column>
            </Grid>
            <Grid utils={{ vrBottom: "md" }}>
              <Grid.Column>
                <Type
                  element="span"
                  size="lg"
                  variant="information"
                  weight="semibold"
                  onClick={searchByPhoneNumberLastname}
                  data-testid="back-to-primary-lookup"
                >
                  {getTranslatedText(TRANSLATION_CONSTANTS.SEARCH_BY_PHONE_NUMBER_LAST_NAME)}
                </Type>
              </Grid.Column>
            </Grid>
          </>
        )}
      </React.Fragment>
    </>
  );
};

export default TransactionNumberLookup;
